export const ROUTES = {
	auth: '/auth',

	myClients: '/my-clients',
	myClient: '/my-client/',

	profile: '/profile',

	apk: '/apk',
	apkBuilder: '/apk/builder',
	apkDomains: '/apk/domains',
	apkDomain: '/apk/domains/',
	apkBuilds: '/apk/builds',

	/** @deprecated use apkBuilder */
	builder: '/builder',
	/** @deprecated use apkDomains */
	domains: '/domains',
	/** @deprecated use apkDomain */
	domain: '/domains/',

	clients: '/clients',
	client: '/client/',

	workers: '/workers',
	worker: '/workers/',

	admin: '/admin',
	adminUsers: '/admin/users',
	adminUser: '/admin/users/',
	adminStats: '/admin/stats',
	adminSettings: '/admin/settings',
	adminSenderProxies: '/admin/sender/proxies',
	adminBuilderQueue: '/admin/builder-queue',
	adminCardFill: '/admin/card-fill',

	landings: '/landings',
	landingsNotification: '/landings/notification',
	landingsDomains: '/landings/domains',
	landingsDomain: '/landings/domains/',
	landingsSites: '/landings/sites',
	landingsLinks: '/landings/links',
	landingsMetaPixels: '/landings/meta-pixels',
	landingsTemplates: '/landings/templates',
	landingsTelegramAuthTemplates: '/landings/telegram-auth-templates',
	landingsTelegramAuthConstructor: '/landings/telegram-auth-constructor',
	landingsEvents: '/landings/events',

	sender: '/sender',
	senderOverview: '/sender/overview',
	senderSpammer: '/sender/spammer',
	senderSpammerSettings: '/sender/spammer/settings',
	senderSpammerConsole: '/sender/spammer/console',
	senderStats: '/sender/stats',
	senderSessions: '/sender/sessions',
	senderRuns: '/sender/runs',
	senderRun: '/sender/runs/',
	senderSettings: '/sender/settings',
	senderAuthJobs: '/sender/auth-jobs',
	senderLaunch: '/sender/launch',
} as const;

/** Legacy bookmark paths — redirect to {@link ROUTES.sender} in router. */
export const SENDER_LEGACY_REDIRECT_PATHS = [
	'/sender/campaigns',
	'/sender/campaigns/',
	'/sender/runs/new',
	'/sender/builds',
] as const;
